/**
 * MRP Weekly Order Plan (/mrp/weekly-plan) — output page.
 *
 * Run selector + week cards + ALL/COMMON/BRAND_SPECIFIC + category /
 * vendor filters + plan export + weekly-PO preview / template
 * download / upload.
 */
import MRPDashboard from '@/pages/MRPDashboard';

export default function MRPWeeklyPlan() {
  return <MRPDashboard view="weekly-plan" />;
}
